import React from "react";
import "./What_We_Do.css";
import Common_Headings from "../../common_components/common_heading/Common_Headings";

const What_We_Do = () => {
  return (
    <div className="wwd-container container">
      <Common_Headings title="WHAT WE DO" />

      <div className="wwd-grid-wrapper">
        <div className="wwd-column">
          <div className="wwd-item">
            <span className="wwd-number">01</span>
            <p className="wwd-text">
              Help customers find verified vendors for materials
            </p>
          </div>
          <div className="wwd-divider"></div>
          <div className="wwd-item">
            <span className="wwd-number">03</span>
            <p className="wwd-text">
              Enable direct calling for faster communication & better service
            </p>
          </div>
        </div>

        <div className="wwd-logo-container">
          <div className="wwd-logo-box">
            <img src="/assets/header/nova-prime-logo.png" alt="Nova Prime" className="nova-logo" />
          </div>
        </div>

        <div className="wwd-column">
          <div className="wwd-item">
            <span className="wwd-number">02</span>
            <p className="wwd-text">
              Connect customers with skilled experts & technicians
            </p>
          </div>
          <div className="wwd-divider"></div>
          <div className="wwd-item">
            <span className="wwd-number">04</span>
            <p className="wwd-text">
              Support vendors and experts to grow their business
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default What_We_Do;
